var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "item" }, [
    _c("div", { staticClass: "item__title" }, [
      _c("span", { staticClass: "item__date" }, [
        _vm._v(_vm._s(_vm.dateParser(_vm.inspection.startDate))),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "item__number" }, [
        _vm._v(_vm._s(_vm.inspection.number)),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item__info" }, [
      _vm.inspection.inspect_type
        ? _c("p", [
            _c("b", [_vm._v("Вид проверки:")]),
            _vm._v(" " + _vm._s(_vm.inspection.inspect_type) + " "),
            _vm.inspection.verify_type
              ? _c("span", [
                  _vm._v("(" + _vm._s(_vm.inspection.verify_type) + ")"),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.inspection.inspectedCompanyName
        ? _c("p", [
            _c("b", [_vm._v("Проверяемое подразделение:")]),
            _vm._v(" " + _vm._s(_vm.inspection.inspectedCompanyName)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.inspection.inspectedCompanyAddress
        ? _c("p", [
            _c("b", [_vm._v("Адрес:")]),
            _vm._v(" " + _vm._s(_vm.inspection.inspectedCompanyAddress)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.inspection.inspectingCompanyName
        ? _c("p", [
            _c("b", [_vm._v("Проверяющий орган:")]),
            _vm._v(" " + _vm._s(_vm.inspection.inspectingCompanyName)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.inspection.target
        ? _c("p", [
            _c("b", [_vm._v("Цель проверки:")]),
            _vm._v(" " + _vm._s(_vm.inspection.target)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.inspection.violations.length
        ? _c("div", { staticClass: "violations" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.inspection.violations, function (v, i) {
                return _c("li", { key: i }, [
                  v.result
                    ? _c("p", [
                        _c("b", [_vm._v("Результаты проверки:")]),
                        _vm._v(" " + _vm._s(v.result)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  v.instruction
                    ? _c("p", [
                        _c("b", [_vm._v("Предписание:")]),
                        _vm._v(" " + _vm._s(v.instruction)),
                      ])
                    : _vm._e(),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("b", [_vm._v("Нарушения:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }